import { instance } from "./instance";
import { ProfileResponse, ProfilesResponse } from "../types/profile";

const axios = instance("PROFILE");

export const getProfiles = async (stationId: string): Promise<ProfilesResponse> => {
    const response = await axios.get<ProfilesResponse>(`profile?stationId=${stationId}`);
    return response.data;
};

export const getProfile = async (profileId: string): Promise<ProfileResponse> => {
    const response = await axios.get<ProfileResponse>(`profile/${profileId}`);
    return response.data;
};

export const getProfilesByIds = async (profileIds: string[]): Promise<ProfilesResponse> => {
    const response = await axios.get<ProfilesResponse>(`profile/profiles?profileIds=${profileIds.join(',')}`);
    return response.data;
};